import * as bootstrap from 'bootstrap';
import '@fortawesome/fontawesome-free/js/all.js';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

/** Toggle theme */
( function () {
	'use strict';
  const storageName = 'theme';
  const darkTheme = 'dark';
  const brightTheme = 'bright';
  const header = document.getElementById('header');
  const toggleSwitch = document.getElementById('warning-toggle');
  const bannerImage = document.getElementById('warning-banner');
  const burgerImage = document.getElementById('warning-burger');
  const switchImage = document.getElementById('warning-switch-image');
  const bodyClasses = document.body.classList;
  console.log('header', header);

  const isDark = (item) => item === darkTheme;

  let currentTheme = 'brightTheme';

  if(isDark(localStorage.getItem(storageName))) {
	  bodyClasses.add(darkTheme);
	  header.classList.add('navbar-dark');
	  header.classList.remove('navbar-light');
    currentTheme = darkTheme;
    bannerImage.src = bannerImage.src.replace(brightTheme, darkTheme);
    burgerImage.src = burgerImage.src.replace(darkTheme, brightTheme);
    switchImage.src = switchImage.src.replace(darkTheme, brightTheme);
  }

  toggleSwitch.addEventListener('click', function() {
    bodyClasses.toggle(darkTheme);

    if(isDark(currentTheme)) {
      currentTheme = brightTheme;
      bannerImage.src = bannerImage.src.replace(darkTheme, brightTheme);
      burgerImage.src = burgerImage.src.replace(brightTheme, darkTheme);
      switchImage.src = switchImage.src.replace(brightTheme, darkTheme);
      localStorage.setItem(storageName, brightTheme);
  	  header.classList.add('navbar-light');
  	  header.classList.remove('navbar-dark');
    } else {
      currentTheme = darkTheme;
      bannerImage.src = bannerImage.src.replace(brightTheme, darkTheme);
      burgerImage.src = burgerImage.src.replace(darkTheme, brightTheme);
      switchImage.src = switchImage.src.replace(darkTheme, brightTheme);
      localStorage.setItem(storageName, darkTheme);
  	  header.classList.add('navbar-dark');
  	  header.classList.remove('navbar-light');
    }
  })

} )();